import { Link, useForm } from '@inertiajs/react';
import classNames from 'classnames';
import React from 'react';
import useRoute from '@/Hooks/useRoute';
import GuestLayout from '@/Layouts/GuestLayout';
import { Button } from '@/Components/ui/button';
import { Label } from '@/Components/ui/label';
import { Input } from '@/Components/ui/input';
import { router } from '@inertiajs/core';

export default function Register() {
  const route = useRoute();
  const { data, setData, post, errors, processing, reset } = useForm({
    email: '',
    password: '',
  });

  return (
    <GuestLayout
      title={'Register'}
      button={
        <Button
          variant="ghost"
          className="absolute right-4 top-4 md:right-8 md:top-8"
          onClick={() => {
            router.visit(route('login'));
          }}
        >
          Login
        </Button>
      }
    >
      <div className="lg:p-8">
        <div className="mx-auto flex w-full flex-col justify-center space-y-8 sm:w-[350px]">
          <div className="flex flex-col space-y-2">
            <h1 className="text-2xl font-semibold tracking-tight">
              Create an account
            </h1>
            <p className="text-sm text-muted-foreground">
              Enter your email below to create your account
            </p>
          </div>
          <div className="flex flex-col gap-4">
            <div className="flex flex-col gap-2">
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                placeholder="Type your email"
                value={data.email}
                onChange={e => {
                  setData('email', e.currentTarget.value);
                }}
              />
              <p className="text-destructive text-xs">{errors.email}</p>
            </div>
            <div className="grid gap-2">
              <Label htmlFor="password">Password</Label>
              <Input
                id="password"
                type="password"
                placeholder="Type your password"
                value={data.password}
                onChange={e => {
                  setData('password', e.currentTarget.value);
                }}
              />
              {!errors.password && (
                <p className="text-slate-500 text-xs font-light">
                  Must be at least 8 characters
                </p>
              )}
              {errors.password && (
                <p className="text-destructive text-xs">{errors.password}</p>
              )}
            </div>
            <Button
              className={classNames({
                'opacity-25': processing,
              })}
              disabled={processing}
              onClick={() => {
                post(route('register'));
              }}
            >
              Sign Up
            </Button>
          </div>
          <div className="relative">
            <div className="absolute inset-0 flex items-center">
              <span className="w-full border-t"></span>
            </div>
            <div className="relative flex justify-center text-xs uppercase">
              <span className="bg-background px-2 text-muted-foreground">
                Or continue with
              </span>
            </div>
          </div>
          <Button className="flex gap-2" variant="outline" asChild>
            <a href="/redirect/google">
              <img src={'/images/google.svg'} alt={'google-logo'}></img>
              <span>Sign up with Google</span>
            </a>
          </Button>
          <p className="text-sm text-muted-foreground font-light">
            By clicking {'"Sign up"'}, you agree to our{' '}
            <a
              className="underline"
              href="https://superrep.ai/terms-of-service"
              target="_blank"
              rel="noreferrer"
            >
              Terms of Service
            </a>{' '}
            and{' '}
            <a
              className="underline"
              href="https://superrep.ai/privacy-policy"
              target="_blank"
              rel="noreferrer"
            >
              Privacy Policy.
            </a>
          </p>
          <p className="text-sm text-muted-foreground font-light">
            Already have an account ?{' '}
            <Link className="text-slate-800 font-medium" href={route('login')}>
              Log In
            </Link>
          </p>
        </div>
      </div>
    </GuestLayout>
  );
}
